export default __webpack_public_path__ + "static/media/hs4.743426fc.svg";